import React, { useState, useEffect } from "react"
import axios from "axios"
import "../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css"
import { getTransection, exportTransection } from "../CampaignNew/templates/NewsVote2024/service"
import { Pagination } from "semantic-ui-react"
import Spinner from "react-bootstrap/Spinner"

import _get from "lodash/get"
var ReactBsTable = require("react-bootstrap-table")
var BootstrapTable = ReactBsTable.BootstrapTable
var TableHeaderColumn = ReactBsTable.TableHeaderColumn

const TransactionTable = (props) => {
	const [data, setData] = useState([])
	const [activePage, setActivePage] = useState(1)
	const [totalPage, setTotalPage] = useState(0)
	const [total, setTotal] = useState(0)
	const [limit, setLimit] = useState(10)
	const [isLoading, setIsLoading] = useState(false)
	// Search state
	const [searchText, setSearchText] = useState("")
	const [dateFrom, setDateFrom] = useState("")
	const [dateTo, setDateTo] = useState("")
	const [selectedStatus, setSelectedStatus] = useState("")

	const LinkInvoicePDF = (cell, row) => {
		if (row?.invoicePdf) {
			return (
				<a href={row.invoicePdf} target="_blank" rel="noopener noreferrer">
					View PDF
				</a>
			)
		}
		return "-"
	}

	useEffect(() => {
		// Sample data with 20 columns
		fetchData()
	}, [])

	const fetchData = async (searchParams = {}) => {
		const body = {
			// campaignId:campaignId,
			page: activePage,
			limit: limit,
			...searchParams,
		}
		const response = await getTransection(body)
		const _data = _get(response, "data.data.data", [])
		setTotalPage(_get(response, "data.data.totalPages", 0))
		setTotal(_get(response, "data.data.total", 0))
		setData(_data)
	}

	// Search handlers
	const handleSearch = (page) => {
		const searchParams = {}
		if (searchText) searchParams.search = searchText
		if (dateFrom) searchParams.dateFrom = dateFrom
		if (dateTo) searchParams.dateTo = dateTo
		if (selectedStatus) searchParams.status = selectedStatus

		fetchData({ page, ...searchParams })
	}

	const handleReset = () => {
		setSearchText("")
		setDateFrom("")
		setDateTo("")
		setSelectedStatus("")
		fetchData()
	}

	const exportCSV = async () => {
		setIsLoading(true)
		try {
			const searchParams = {}
			if (searchText) searchParams.search = searchText
			if (dateFrom) searchParams.dateFrom = dateFrom
			if (dateTo) searchParams.dateTo = dateTo
			if (selectedStatus) searchParams.status = selectedStatus

			const res = await exportTransection(searchParams)

			const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }))
			const link = document.createElement("a")
			link.href = url
			link.download = "Campaign_Transaction.csv"
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
			link.remove()
			window.URL.revokeObjectURL(url)
		} catch (error) {
			console.error("Error exporting CSV:", error)
		}
		setIsLoading(false)
	}

	const options = {
		sizePerPage: limit,
		defaultSortName: "id",
		defaultSortOrder: "desc",
	}

	const pagination = async (e, pageInfo) => {
		setActivePage(pageInfo.activePage)
		handleSearch(pageInfo.activePage)
	}

	const columns = [
		{
			key: "Transaction ID",
			label: "Transaction ID",
			width: 250,
			isKey: true,
			format: (cell) => cell || "-",
		},
		{ key: "เบอร์โทรศัพท์", label: "เบอร์โทร", width: 100, format: (cell) => cell || "-" },
		{ key: "Package Name", label: "Package Name\nชื่อแพ็คเกจ", width: 150 },
		{ key: "Package Price", label: "Package Price\nราคาแพ็คเกจ", width: 125 },
		{ key: "Price/Unit -  VAT7%", label: "Price/Unit -  VAT7%\nราคาต้นทุน", width: 150 },
		{ key: "Vatจากราคาต้นทุน", label: "Vat จากราคาต้นทุน\n7%", width: 150 },
		{ key: "WHT จากราคาต้นทุน", label: "WHT\nจากราคาต้นทุน", width: 150 },
		{ key: "Package Price", label: "ราคาซื้อ", width: 150 },
		{
			key: "Transaction fee (If Promptpay)",
			label: "Transaction fee\n(If Promptpay)\n1.20%",
			width: 125,
		},
		{
			key: "Transaction fee (If Credit card)",
			label: "Transaction fee\n(If Credit card)\n2.50%",
			width: 125,
		},
		{
			key: "Transaction fee (If Alipay)",
			label: "Transaction fee\n(If Alipay)\n2.50%",
			width: 125,
		},
		{
			key: "Transaction fee (If True Money Wallet)",
			label: "Transaction fee\n(If True Money Wallet)\n1.80%",
			width: 125,
		},
		{
			key: "Vat",
			label: "Vat\n7%",
			width: 75,
		},
		{
			key: "Total Omise fee",
			label: "Total Omise fee",
			width: 150,
		},
		{
			key: "Net Revenue",
			label: "Net Revenue\nราคาซื้อ - Total omise",
			width: 175,
		},
		{
			key: "สถานะการชำระเงิน",
			label: "สถานะการชำระเงิน",
			width: 150,
		},
		{
			key: "วันที่สร้างคำสั่งซื้อ",
			label: "วันที่สร้างคำสั่งซื้อ",
			width: 200,
			// format: (cell) => getDateFormatterAdd7(cell),
		},
		{
			key: "วันที่ชำระเงินสำเร็จ",
			label: "วันที่ชำระเงิน",
			width: 200,
			// format: (cell) => getDateFormatterAdd7(cell),
		},
		{
			key: "invoicePdf",
			label: "PDF Invoice",
			format: LinkInvoicePDF,
			width: 100,
		},
	]
	return (
		<div className="card shadow mb-4">
			<div className="card-header py-3">
				<h6 className="m-0 font-weight-bold text-primary">Transaction Table</h6>
			</div>
			<div className="card-body">
				<div className="container d-flex">
					<div className="row col-8">
						<div className="input-group md-form form-sm form-2 pl-0">
							<input
								className="form-control my-0 py-1 lime-border w-100"
								type="text"
								placeholder="ค้นหา..."
								aria-label="Search"
								value={searchText}
								onChange={(e) => setSearchText(e.target.value)}
							/>
						</div>
					</div>
					<button
						className="btn btn-success btn-icon-split"
						onClick={() => {
							setActivePage(1)
							handleSearch()
						}}
					>
						<span className="icon text-white-50">
							<i className="fas fa-search"></i>
						</span>
						<span className="text">ค้นหาข้อมูล</span>
					</button>
				</div>

				<br />

				<div className="container">
					<div className="card card-body" id="collapseExample">
						<div className="row">
							<div className="col-3">Create Date From</div>
							<div className="col-3">Create Date To</div>
							<div className="col-3">Status</div>
						</div>
						<div className="row">
							<div className="col-3">
								<div className="row">
									<div className="col-12">
										<input type="date" className="form-control" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
									</div>
								</div>
							</div>
							<div className="col-3">
								<div className="row">
									<div className="col-12">
										<input type="date" className="form-control" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
									</div>
								</div>
							</div>
							<div className="col-3">
								<div className="row">
									<div className="col-12">
										<div className="input-group">
											<select className="custom-select" value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
												<option value="">ทั้งหมด</option>
												<option value="success">ชำระเงินสำเร็จ</option>
												<option value="failed">หมดเวลาการชำระเงิน</option>
												<option value="waiting">รอการชำระเงิน</option>
											</select>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<br />
				<div className="row" style={{ marginBottom: "8px" }}>
					<div className="col-10">
						<button className="btn btn-secondary" onClick={handleReset} style={{ minWidth: "120px", height: "41px" }}>
							รีเซ็ต
						</button>
						{isLoading ? (
							<button className="btn btn-secondary" style={{ width: "120px", height: "41px", marginLeft: "8px" }}>
								<Spinner animation="border" role="status" variant="success">
									<span className="sr-only">Loading...</span>
								</Spinner>
							</button>
						) : (
							<button className="btn btn-secondary" onClick={exportCSV} style={{ minWidth: "120px", height: "41px", marginLeft: "8px" }}>
								Export to CSV
							</button>
						)}
					</div>
					<div className="col-2">จำนวนข้อมูล {total}</div>
				</div>
				<div className="table-responsive">
					<BootstrapTable data={data} className="table table-striped">
						{columns.map((col) => (
							<TableHeaderColumn key={col.key} dataField={col.key} width={col.width} isKey={col.isKey} dataFormat={col.format} dataAlign="center">
								{col.label.split("\n").map((line, i) => (
									<React.Fragment key={i}>
										{line}
										<br />
									</React.Fragment>
								))}
							</TableHeaderColumn>
						))}
					</BootstrapTable>

					{data.length !== 0 && <Pagination activePage={activePage} onPageChange={pagination} totalPages={totalPage} ellipsisItem={null} />}
				</div>
			</div>
		</div>
	)
}

export default TransactionTable
